export default __webpack_public_path__ + "static/media/header.9d0931eb.jpeg";